/* eslint-disable */
var baseApiUrl = ''
var appBaseUrl = ''
if (process.env.NODE_ENV === 'production') {
  // baseApiUrl = 'https://commenting-tool-demo-api-v2.geodemosolutions.com/public/'
  // appBaseUrl = 'https://commenting-tool-demo-v2.geodemosolutions.com/#/'
  baseApiUrl = 'https://irsp-commenting-tool-api.geodemosolutions.com/public/'
  appBaseUrl = 'https://irsp-commenting-tool.geodemosolutions.com/#/'
 }
else {
  baseApiUrl = 'http://localhost/irsp-commenting-tool-api/public/'
  appBaseUrl = 'http://localhost:1700/#/'
}

export {
  baseApiUrl,
  appBaseUrl
}
